import React from "react";

function ContactForm() {
  return (
    <>
      <div className="bg-light-gray py-5">
        <div className="container">
          <div className="row justify-content-center py-5">
            <div className="col-12 col-md-8">
              <h2
                className="text-center ff_josfin color-light-black font-2xl text-uppercase px-lg-3 "
                data-aos="fade-right"
                data-aos-duration="400"
                data-aos-delay="200"
              >
                Whether its partnership related or if its a business enquiry -{" "}
                <span className="color-dark-blue d-block">
                  {" "}
                  We'll be in touch!
                </span>
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div
        className="bg-light-white pb-5"
        data-aos="fade-up"
        data-aos-duration="800"
        data-aos-delay="300"
      >
        <div className="container mb-md-5 pb-lg-5">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-7">
              <form
                action=""
                className="form_bg_clases mx-md-4 pt-4 pb-4 px-3 px-md-5"
              >
                <input
                  type="text"
                  placeholder="Full Name*"
                  name=""
                  id=""
                  className="w-100 input-common-clases"
                  required
                />
                <input
                  type="email"
                  placeholder="Email*"
                  name=""
                  id=""
                  required
                  className="w-100 my-3 input-common-clases"
                />
                <input
                  type="number"
                  placeholder="Phone Number*"
                  name=""
                  id=""
                  required
                  className="w-100 input-common-clases"
                />
                <input
                  type="text"
                  placeholder="LinkedIn Profile*"
                  name=""
                  id=""
                  required
                  className="w-100 mt-3 mb-2 input-common-clases"
                />
                <select
                  className="input-common-clases w-100 mb-3 mt-2"
                  name=""
                  id=""
                  required
                >
                  <option value=""> Area of Interest </option>
                  <option value=""> Choose Two </option>
                  <option value=""> Choose Three </option>
                  <option value=""> Choose Four </option>
                </select>
                <textarea
                  className="input-common-clases w-100"
                  placeholder="Message*"
                  name=""
                  id=""
                  cols="10"
                  rows="2"
                  required
                ></textarea>
                <div className="text-center mt-4 mb-2">
                  <button
                    type="submit"
                    className="submit-btn color-white font-medium font-xs"
                  >
                    SUBMIT
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContactForm;
